import { Component, inject, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OwnerService, Owner } from '../services/owner.service';

@Component({
  selector: 'app-owner-management',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './owner-management.component.html',
  styleUrls: ['./owner-management.component.css']
})
export class OwnerManagementComponent {
  private ownerService = inject(OwnerService);
  owners$: Observable<Owner[]>;
  
  newOwner: Owner = { name: '', email: '', phone: '', showTotalDistribution: false };
  editingId: string | null = null;
  isModalOpen = false;
  isSaving = false;

  constructor() {
    this.owners$ = this.ownerService.getOwners().pipe(
      map(owners => [...owners].sort((a, b) => a.name.localeCompare(b.name)))
    );
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscKey(event: Event) {
    if (this.isModalOpen && !this.isSaving) {
      this.cancelEdit();
    }
  }

  openAddModal() {
    this.cancelEdit();
    this.isModalOpen = true;
  }

  async saveOwner() {
    if (!this.newOwner.name || !this.newOwner.email) return;

    this.isSaving = true;
    try {
      if (this.editingId) {
        await this.ownerService.updateOwner(this.editingId, this.newOwner);
        this.editingId = null;
      } else {
        await this.ownerService.addOwner(this.newOwner);
      }
      
      this.newOwner = { name: '', email: '', phone: '', showTotalDistribution: false };
      this.isModalOpen = false;
    } finally {
      this.isSaving = false;
    }
  }

  editOwner(owner: Owner) {
    this.newOwner = { ...owner };
    this.editingId = owner.id || null;
    this.isModalOpen = true;
  }

  cancelEdit() {
    this.newOwner = { name: '', email: '', phone: '', showTotalDistribution: false };
    this.editingId = null;
    this.isModalOpen = false;
  }

  async deleteOwner(id?: string) {
    if (id && confirm('Are you sure you want to delete this owner? This will remove them from all companies.')) {
      await this.ownerService.deleteOwner(id);
    }
  }
}